import FeatureItem from "./FeatureItem";
import useScreenSize from "../hooks/useScreenSize";

export default function ExperienceSection() {
  const { isMobile, isTablet } = useScreenSize();

  return (
    <section
      style={{
        background: "#EFE8DD",
        padding: isMobile ? "80px 20px" : "120px 32px",
      }}
    >
        <div
          style={{
            maxWidth: 1300,
            margin: "0 auto",
            display: "flex",
            flexDirection: isTablet ? "column" : "row",
            alignItems: "center",
            gap: 60,
          }}
        >

        {/* Image */}

        <div
          style={{
            width: isTablet ? "100%" : "85%",
            margin: "0 auto",
            padding: 16,
            background: "#FFF",
            border: "1px solid rgba(201,166,107,.35)",
            position: "relative",
            boxShadow: "0 18px 45px rgba(0,0,0,.08)",
          }}
        >
          {/* Top-left corner */}
          <div
            style={{
              position: "absolute",
              top: -6,
              left: -6,
              width: 60,
              height: 60,
              borderTop: "3px solid #C9A66B",
              borderLeft: "3px solid #C9A66B",
            }}
          />

          {/* Bottom-right corner */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              right: -6,
              width: 60,
              height: 60,
              borderBottom: "3px solid #C9A66B",
              borderRight: "3px solid #C9A66B",
            }}
          />

          <img
            src="/assets/room/40.png"
            alt="Ebenezer Serviced Apartments"
            loading="lazy"
            style={{
              width: "100%",
              height: isMobile ? 350 : isTablet ? 500 : 650,
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
        
        {/* Content */}

        <div
          style={{
            width: isTablet ? "100%" : "45%",
            textAlign: isTablet ? "center" : "left",
          }}
        >

          <p
            style={{
              color: "#C9A66B",
              letterSpacing: ".16em",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: isMobile ? 12 : 14,
              marginBottom: 18,
            }}
          >
            EXPERIENCE
          </p>

          <h2
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: isMobile ? 36 : isTablet ? 44 : 52,
              lineHeight: 1.15,
              color: "#222",
              marginBottom: 28,
            }}
          >
            Every stay is
            <br />
            crafted for comfort.
          </h2>

          <p
            style={{
              color: "#666",
              lineHeight: 1.9,
              fontSize: isMobile ? 16 : 18,
              marginBottom: 42,
              maxWidth: isTablet ? 700 : "100%",
              marginInline: isTablet ? "auto" : 0,
            }}
          >
            Whether you're visiting Bengaluru for work, relocation,
            medical travel or a family holiday, our serviced apartments
            combine the warmth of home with thoughtful hospitality and
            modern conveniences.
          </p>

          <div
            style={{
              display: "grid",
              gap: 22,
              maxWidth: isTablet ? 520 : "100%",
              margin: isTablet ? "0 auto" : 0,
            }}
          >
            <FeatureItem
              text="Fully furnished serviced apartments"
              isMobile={isMobile}
            />

            <FeatureItem
              text="Complimentary high-speed Wi-Fi"
              isMobile={isMobile}
            />

            <FeatureItem
              text="Daily housekeeping service"
              isMobile={isMobile}
            />

            <FeatureItem
              text="Private kitchenette & dining area"
              isMobile={isMobile}
            />

            <FeatureItem
              text="Prime Whitefield location"
              isMobile={isMobile}
            />

            <FeatureItem
              text="Ideal for long and short stays"
              isMobile={isMobile}
            />
          </div>
        </div>
      </div>
    </section>
  );
}